import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Tabs } from 'antd';
import qs from 'qs';
import { getSessionObject } from '@/tools/utils'
import LoginPassword from './login-password';
import LoginPhone from './login-phone';
import LoginSwitch from './login-switch';


const { TabPane } = Tabs;

const CommonLogin = (props) => {
    const location = useLocation();
    const history = useHistory();

    const qsStr = location.search.replace('?', '');
    const qsObj = qs.parse(qsStr);
    const [loginType, setLoginType] = useState(qsObj.loginType || '');

    useEffect(() => {
        const qsStr = location.search.replace('?', '');
        const qsObj = qs.parse(qsStr);
        setLoginType(qsObj.loginType || 'password');
    }, [loginType, location]);

    // 存在loginData则说明已经登录，需要进行选择商户或者统一密码
    useEffect(() => {
        const loginData = getSessionObject('loginData') || {};
        if (loginData.needUnifiedPwd) {
            history.push('/login/unify');
            return;
        }
        // 判断是否存在多个关联商户，需要选择所登录的商户
        if (loginData.merchants && loginData.merchants.total > 1) {
            history.push('/login/select');
            return;
        }
    }, []);

    const changeLabel = (activeKey) => {
        history.push(`/login?loginType=${activeKey}`);
    };

    return (
        <div style={{padding: '10px 56px 0px 20px', margin: '26px 0 48px'}}>
            <Tabs defaultActiveKey={loginType} onChange={changeLabel} centered>
                <TabPane tab='密码登录' key='password'>
                    <LoginPassword></LoginPassword>
                </TabPane>
                <TabPane tab='验证码登录' key='phone'>
                    <LoginPhone></LoginPhone>
                </TabPane>
            </Tabs>
            <LoginSwitch></LoginSwitch>
        </div>
    );
};
export default CommonLogin;